import math from "mathjs"


let matheval = math.eval

let questionTypes = []

questionTypes.push({
	id: 'one',
	Id: 'One',
	buttonText: 'Frage mit einer Lösung'
})

// questionTypes.push({
// 	id: 'multiple-choice',
// 	Id: 'MultipleChoice',
// 	buttonText: 'Multiple Choice Test'
// })

export {questionTypes}


/* Math Helpers - don't forget to "register" in annas regular expressions */
let mathHelper = require('./helper.math.js')

const ggT = mathHelper.ggT
const kgV = mathHelper.kgV
const kgV_wert = mathHelper.kgV_wert
const b = mathHelper.b
const fac = mathHelper.fac
const bin = mathHelper.bin
const bv = mathHelper.bv
const kbv = mathHelper.kbv


function escapeRegExp(str) {
	return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

function replaceMathHelper(str){

	// let finder = str.match(/bv\(((?>[^()]+)|(?R))*\)/g)
	/* könnte ich umgehen, wenn ich im anderen Regex nested Klammern hingriegen würde
	* bv() wird aber nicht ordnungsgemäß gefunden, wenn sowas steht wie bv( 1, ceil(2.3), 3)
	* es kommt dann nur bv(1, ceil(2.3) zurück. 
	* ich müsste dem also irgendwie per regex rechnung tragen
	* wobei es hinfällig ist, da ceil eh noch ein math. bekommen muss
	*/
	// let ceilFinder = str.match(/ceil\(((?!\)|:an:|§).)*\)/g)
	/* die variante lässt einfach keine klammern drin zu */
	let ceilFinder = str.match(/(ceil|floor)\([^()]*\)/g)
	// console.log('ceil or floor Finder', ceilFinder)
	ceilFinder && ceilFinder.forEach( v => {
		// let e = eval('math.' + v)
		let e = matheval(v)

		// console.log('Switche', e, ' durch ', v)

		str = str.replace( new RegExp(escapeRegExp(v), "g"), e)
	})



	/* eintauschen, sofern nicht :an: oder § drin ist. Dann nicht. */
	let findings = str.match(/(ggT|kgV|kgV_wert|b|fac|bin|kbv|bv)\(((?!\)|:an:|§).)*\)/g)
	findings && findings.forEach( v => {
		// console.log('Wanna eval', v)

		let e = eval(v)
		// let e = matheval(v)
		str = str.replace( new RegExp(escapeRegExp(v), "g"), e)
	})

	return str
}


export const toUrl = (str) => str.replace(/ /g, '-')


export const anna = (str, forShow) => {
	// console.log('AnnA', str)

	let findings

	str = replaceMathHelper(str)

	// console.log('String: ', str)

	/*
	* Doppelter code, weil einmal nach "$:an:<string>:na>$"
	* und einmal nur nach ":an:<string>:na:" gesucht wird.
	* Im ersteren Fall werden beim Show die Punkte gegen "{{,}}" eingetauscht.
	* Im zweiten Fall werden Punkte nur gegen "." eingetauscht.
	*/

	/* erstmal alle in einem mathjax. die sind immer für forShow */

	if(forShow){

		// findings = str.match(/\$:an:((?!:na:).)*:na:\$/g)
		findings = str.match(/\$(:an:|§)((?!:na:|§).)*(:na:|§)\$/g)
		// console.log('Findings', findings)
		// console.log('Findings', findings)

		findings && findings.forEach( v => {

			// v = replaceMathHelper(v)

			let toEval = v.charAt(0) == '§'
			? v.substring(1, v.length - 1)
			: v.substring(4, v.length - 4)

			// let leEval = math.eval(toEval)
			let leEval = matheval(toEval)

			leEval = (''+leEval).replace(/\./g, '{{,}}')

			str = str.replace(v, leEval)
		})
	}

	/* dann alle, die nicht im mathjax sind */
	// findings = str.match(/:an:((?!:na:).)*:na:/g)
	findings = str.match(/(:an:|§)((?!:na:|§).)*(:na:|§)/g)
	// console.log('Findings', findings)

	findings && findings.forEach( v => {

		// v = replaceMathHelper(v)

		let toEval = v.charAt(0) == '§'
		? v.substring(1, v.length - 1)
		: v.substring(4, v.length - 4)

		// let leEval = math.eval(toEval)
		let leEval = matheval(toEval)

		/* Könnten auch für forShow sein */
		if(forShow) leEval = (''+leEval).replace(/\./g, ',')

			str = str.replace(v, leEval)
	})

	return str
}

const videoString = `
<div class="embed-responsive embed-responsive-16by9">
<iframe class="embed-responsive-item" src="{{videourl}}" frameborder="0" allowfullscreen></iframe>
</div>
`

export const video = (str) => {
	if(!str) return str

	// console.log('Im video', str)
	// let findings = str.match(/\[video\]\(((?!\)).)*\)/g)
	let findings = str.match(/\[video:((?!\]).)*\]/g)

	// console.log('VIDEO FINDINGS: ', findings)

	findings && findings.forEach( found => {
		//ouh boy: https://stackoverflow.com/questions/1144783/how-to-replace-all-occurrences-of-a-string-in-javascript?page=1&tab=votes#tab-top
		// str = str.replace(new RegExp(found, 'g'), '-')

		let replacer = videoString.replace('{{videourl}}', found.substring(7, found.length - 1))

		str = str.replace(found, replacer)
	})

	// console.log(str)

	return str
}


// WEBPACK FOOTER //
// ./src/helper.js